import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'appNumber',
  standalone: true,
})
export class DecimalPipeWithCustomFormat implements PipeTransform {
  transform(value: never, digits?: string): string | null {
    const numberPipe = new DecimalPipe('en-US');
    digits ||= '1.0-2';
    return numberPipe.transform(value, digits);
  }
}
